module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('crosstab', {
    attrs: {
      "dataUrl": "https://raw.githubusercontent.com/amalieiev/vue-crosstab/master/docs/data/salary.json",
      "rows": _vm.rows,
      "cols": _vm.cols,
      "transform": _vm.transform
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17eb5f36"}!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/CrosstabExample.vue
// module id = 54
// module chunks = 0